module.exports = __webpack_public_path__ + "assets/img/cdz-select.010a03d3.png";